import { useTranslations } from "next-intl";
import Image from "next/image";

const WarrantyDownpaymentCard = () => {
  const t = useTranslations("CarDetails.warranty");

  return (
    <div className={`rounded-3xl bg-white px-7 py-5`}>
      <div className="flex items-center gap-3">
        <Image alt="" src={"/assets/images/percentage.png"} width={70} height={70} />
        <div className="flex flex-col gap-1">
          <p className="font-inter text-base font-bold text-primary">{t("downpayment")}</p>
          <p className="font-inter text-base font-bold text-black">{t("freeWarranty")}</p>
        </div>
      </div>
    </div>
  );
};

export default WarrantyDownpaymentCard;
